import * as React from "react";
import {
  ApplyingRule,
  IFunctionElementUnion,
  IStaticElementUnion,
  InputElementUnion,
} from "@graffer-inc/form-schema";
import { IRepeatableElementUnion } from "@graffer-inc/form-schema/dist/elements-schema/repeatable-schema";

export const ApplicantThenRuleDisableEditor: React.ComponentType<{
  ifTypeLabel: string;
  thenRule: ApplyingRule;
  thenCandidates: (
    | InputElementUnion
    | IFunctionElementUnion
    | IStaticElementUnion
    | IRepeatableElementUnion
  )[];
}> = ({ thenRule: r, thenCandidates, ifTypeLabel }) => {
  return (
    <>
      <div className="field">
        <label className="label">適用対象</label>
        <p className="control">
          {thenCandidates.find((e) => e.id === r.id)!.label.text}
        </p>
      </div>
      <p className="notification has-text-weight-bold">
        この項目は{ifTypeLabel}には非対応です。
        (申請者の画面上は非表示になります。）
      </p>
    </>
  );
};
